import Layout from '../../components/Layout'

export default function Company() {
  return (
    <Layout>
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-6">Company</h1>
        <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
          <div className="text-text-muted mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <p className="text-text-secondary font-medium">Company coming soon</p>
          <p className="text-sm text-text-muted mt-1">Company-wide settings and information will be here.</p>
        </div>
      </div>
    </Layout>
  )
}
